document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("scroll", handleScroll);
  handleScroll(); // Initial check

  function handleScroll() {
    const stickyAddToCart = document.querySelector('.sticky-bar-form');

    // Find the first form that submits to /cart/add
    const formElement = Array.from(document.querySelectorAll('form'))
      .find(form => form.action.includes('/cart/add'));

    if (!formElement || !stickyAddToCart) return;

    const formRect = formElement.getBoundingClientRect();
    const isMobile = window.innerWidth <= 767;
    const isDesktop = window.innerWidth >= 768;

    // Universal check: if form has scrolled above the viewport (top < 0)
    const formAboveViewport = formRect.top < 10;

    if (formAboveViewport) {
      stickyAddToCart.classList.add("active");
    } else {
      stickyAddToCart.classList.remove("active");
    }

    // Optionally log the values
    // console.log('formRect.top:', formRect.top, '=> above viewport:', formAboveViewport);
  }
});


(function () {
  const SEL = ".sticky-bar-form";
  const MQ  = matchMedia("(max-width: 749.98px)");

  let el = null, mo = null, origRemove = null;

  const q = (s) => document.querySelector(s);

  const forceActive = () => {
    if (!el) return;

    el.classList.add("active");

    const s = el.style;
    ["top","transform","display","visibility"].forEach(p => s.removeProperty(p));
    s.setProperty("position","fixed","important");
    s.setProperty("left","0","important");
    s.setProperty("right","0","important");
    s.setProperty("bottom","0","important");
    s.setProperty("z-index","9998","important");
    s.setProperty("opacity","1","important");
    s.setProperty("pointer-events","auto","important");

    requestAnimationFrame(() => {
      const h = el.offsetHeight || 72;
      document.documentElement.style.setProperty("--sticky-bar-h", `${h}px`);
    });
  };

  const enableMobile = () => {
    el = q(SEL);
    if (!el) return;

    (el.parentElement !== document.body) && document.body.appendChild(el);

    !origRemove
      ? (origRemove = el.classList.remove.bind(el.classList),
         el.classList.remove = (...names) => {
           names = names.includes("active") ? names.filter(n => n !== "active") : names;
           return names.length ? origRemove(...names) : undefined;
         })
      : 0;

    !mo
      ? (mo = new MutationObserver(() => el.classList.contains("active") ? 0 : el.classList.add("active")),
         mo.observe(el, { attributes: true, attributeFilter: ["class"] }))
      : 0;

    forceActive();
  };

  const disableMobile = () => {
    if (!el) return;
    origRemove ? (el.classList.remove = origRemove, origRemove = null) : 0;
    mo ? (mo.disconnect(), mo = null) : 0;
    document.documentElement.style.removeProperty("--sticky-bar-h");
  };

  const onChange = () => (MQ.matches ? enableMobile() : disableMobile());

  document.addEventListener("DOMContentLoaded", onChange);
  (MQ.addEventListener ? MQ.addEventListener("change", onChange) : MQ.addListener(onChange));
  window.addEventListener("load", () => (MQ.matches ? forceActive() : 0));
})();
